import Reveal from "@/components/Reveal";
import { ShieldCheck, BadgeCheck, Users2, Heart } from "lucide-react";

const ITEMS = [
  { icon: BadgeCheck, title: "Verified profiles", body: "Every traveller is reviewed before they're in a group." },
  { icon: Users2, title: "Women-first matching", body: "Thoughtful matching and women-only groups for peace of mind." },
  { icon: ShieldCheck, title: "Host on the ground", body: "We set up every group, stay on the chats, and ensure safety." },
  { icon: Heart, title: "Made for real moments", body: "Small groups, intentional plans, no awkward energy." },
];

export default function Safety() {
  return (
    <section data-testid="safety-section" className="bg-[#FF5A36] text-white relative overflow-hidden">
      <div className="absolute -top-20 -left-20 h-64 w-64 rounded-full bg-white/10 blur-3xl" />
      <div className="absolute -bottom-20 -right-20 h-72 w-72 rounded-full bg-[#FFC857]/30 blur-3xl" />
      <div className="relative max-w-md mx-auto md:max-w-6xl px-5 md:px-8 py-16 md:py-24">
        <Reveal>
          <div className="text-[11px] md:text-xs uppercase tracking-[0.25em] font-semibold text-white/80">
            Safe by design
          </div>
        </Reveal>
        <Reveal delay={80}>
          <h2 className="mt-3 font-display font-extrabold text-3xl md:text-5xl leading-[1.05] tracking-tight text-balance max-w-3xl">
            Safety isn't a feature. It's the foundation.
          </h2>
        </Reveal>

        <div className="mt-10 md:mt-14 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 md:gap-5">
          {ITEMS.map((it, i) => {
            const Icon = it.icon;
            return (
              <Reveal key={it.title} delay={100 + i * 80}>
                <div className="h-full rounded-2xl bg-white/10 backdrop-blur border border-white/15 p-5 md:p-6 transition hover:bg-white/15">
                  <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-white text-[#FF5A36]">
                    <Icon className="h-5 w-5" />
                  </span>
                  <h3 className="mt-4 font-display font-bold text-lg md:text-xl tracking-tight">{it.title}</h3>
                  <p className="mt-1.5 text-white/85 text-sm md:text-[15px] leading-relaxed">{it.body}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
